const dataVisibilityHelper = (arr, key) => {
    if (arr.length === 1 && arr[0] === "all") {
        return true;
    }

    if (Array.isArray(arr)) {
        return !!arr.includes(key);
    }

    return false
}

export default dataVisibilityHelper;